module.exports = __webpack_public_path__ + "img/homeCalandar.2b26c90.svg";